// extracted by mini-css-extract-plugin
export default {"headerWrapper":"PG-z","header":"QG-z","hfImagesComponent":"RG-z","headerContainer":"SG-z"};